<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t('tlt.equipment.list') }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/equipment"><span>{{$t('tlt.equipment.list')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('equipment')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">                                        
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="nameFilter" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.equipment.type") }}:
                                    </label>
                                    <select class="form-control" id="composite"  v-model="typeFilter">
                                        <!-- <option>{{ $t("lbl.basic.select.one") }}</option> -->
                                        <option value="T">{{ $t("lbl.equipment.type.tripperCar") }}</option>
                                        <option value="R">{{ $t("lbl.equipment.type.reclaimer") }}</option>
                                        <option value="S">{{ $t("lbl.equipment.type.stackerReclaimer") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.equipment.area") }}:
                                    </label>
                                    <select class="form-control" id="composite"  v-model="areaFilter">
                                        <!-- <option>{{ $t("lbl.basic.select.one") }}</option> -->
                                        <option>C1</option>
                                        <option>C2</option>
                                        <option>C3</option>
                                        <option>C4</option>
                                        <option>B1</option>
                                        <option>B2</option>
                                        <option>B3</option>
                                        <option>B4</option>
                                        <option>B5</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }}:
                                    </label>
                                    <select class="form-control" id="composite"  v-model="activeFilter">
                                        <!-- <option>{{ $t("lbl.basic.select.one") }}</option> -->
                                        <option value="true">{{ $t("lbl.basic.yes") }}</option>
                                        <option value="false">{{ $t("lbl.basic.no") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.status") }}:
                                    </label>
                                    <select class="form-control" id="composite"  v-model="statusFilter">
                                        <!-- <option>{{ $t("lbl.basic.select.one") }}</option> -->
                                        <option value="r">{{ $t("lbl.equipment.status.running") }}</option>
                                        <option value="f">{{ $t("lbl.equipment.status.malfunction") }}</option>
                                        <option value="e">{{ $t("lbl.equipment.status.examineAndRepair") }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                        v-on:click="MMFClearFilter('equipment')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('equipment')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="equipmentResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="equipment"
                                        inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/master/Equipment";
import MmfTable from "@/components/MmfTable";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'equipment/getField',
    mutationType: 'equipment/updateField',
});

export default {
  name: "equipmentList",
  data () {
    return {
      checkedItems: []
    }
  },
  components: { MmfTable },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.equipment.rows,
            tableColumns: gridFields,
            childs: state => state.equipment.childs
        })
  },
  methods: {

    ...mapActions("equipment", ["loadChildOf"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
      this.$store.dispatch('equipment/loadChildOf');
  }
};
</script>
